var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.128,
    height: 21.128,
    viewBox: "0 0 17.128 21.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M632.991,686.043h-.952V683.93h-1.9v2.113h-7.612V683.93h-1.9v2.113h-.952a2.016,2.016,0,0,0-1.9,2.113v14.79a2.016,2.016,0,0,0,1.9,2.113h13.322a2.016,2.016,0,0,0,1.9-2.113v-14.79A2.016,2.016,0,0,0,632.991,686.043Zm-6.661,3.169a3.187,3.187,0,1,1-2.855,3.169A3.027,3.027,0,0,1,626.33,689.212Zm5.709,12.677H620.621v-1.056c0-2.113,3.806-3.275,5.709-3.275s5.709,1.162,5.709,3.275Z",
    transform: "translate(-617.766 -683.93)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8ee7803675fbeda4f114fcaa9bea513c.svg";
export { ForwardRef as ReactComponent };